<template>
  <div>
    <div class="empty-state">
      <i class="fa fa-address-book fa-4x"></i>
      <span>{{ $t('rsvpDetails.systemLogs.emptyState') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'system-logs',
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.empty-state{
  padding: 30px;
  font-size: 18px;
  color: #999;
  text-align: center;

  .fa{
    display: block;
    margin-bottom: 5px;
    color: #ccc;
    text-shadow:0 0 5px rgba(255,255,255, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RsvpDetails/SystemLogs.vue